import React from 'react';
import cn from 'classnames';
import { ProductTileProps } from "../../../ProductTile/types";
import MetaText from "../../../../ui/Typography/texts/MetaText";
import styles from './ProductColor.module.scss';
const ProductColor = ({ colorLabel, productColor, isProductTileDetailsCentreAligned, productColorTextSize, productColorLabelClassName = '', }) => {
    if (!productColor)
        return null;
    return (React.createElement("dl", { className: cn(styles.dataList, isProductTileDetailsCentreAligned && styles.centreAlignArticleDetails, productColorTextSize === 'large' && styles.largeText) },
        React.createElement(MetaText, { Tag: "dt", className: cn(styles.dataListTerm, productColorLabelClassName) }, colorLabel),
        React.createElement(MetaText, { Tag: "dd", className: cn(styles.dataListDetails, productColorTextSize === 'large' && styles.largeTextDataLists) }, productColor.colorName)));
};
export default ProductColor;
//# sourceMappingURL=ProductColor.js.map